import { gql } from '@apollo/client';

/**
 * Query for getting applications
 */
export const GetApplicationsQuery = gql`
  query CatalogSearchApplications(
    $pagination: PaginationInput
    $filter: ResourceCatalogApplicationFilter
    $sortBy: ResourceCatalogApplicationSortByInput
  ) {
    resources {
      applicationsPaged(
        pagination: $pagination
        filter: $filter
        sortBy: $sortBy
      ) {
        applications {
          appGroup
          applicationId
          description
          informationClassificationPolicy {
            name
          }
          name
          owner {
            displayName
          }
          roles {
            displayName
          }
          status
          updatedAt
        }
        totalCount
      }
    }
  }
`;

/**
 * Query for getting applications by user
 */
export const GetApplicationsByUserQuery = gql`
  query CatalogSearchApplicationsByUser(
    $login: String
    $pagination: PaginationInput
    $filter: ResourceCatalogUserApplicationFilter
  ) {
    identity {
      user(login: $login) {
        resources {
          applicationsPaged(pagination: $pagination, filter: $filter) {
            applications {
              appGroup
              applicationId
              description
              informationClassificationPolicy {
                name
              }
              name
              owner {
                displayName
              }
              roles {
                displayName
              }
              status
              updatedAt
            }
            totalCount
          }
        }
      }
    }
  }
`;

/**
 * Query for getting devices
 */
export const GetDevicesQuery = gql`
  query CatalogSearchGetDevicesQuery(
    $pagination: PaginationInput
    $filter: ResourceCatalogDeviceFilter
  ) {
    resources {
      devicesPaged(pagination: $pagination, filter: $filter) {
        devices {
          deviceId
          hostname
          type
          ipAddress
          fqdn
          environment
          location
          serialNumber
          tier
          href
          osInfo {
            make
            name
            edition
            release
            version
          }
          applicationsPaged {
            applications {
              name
              applicationId
            }
          }
          attributes {
            id
            deviceId
            key
            value
          }
          tags
          hardening {
            deviceId
            patcherJobId
            state
            hbaWwn
            osPackageRepo
            osPatchMethod
            osPatchDate
            osHardenVersion
            osHardenDate
            osPatchVersion
            osImageVersion
            osStandardVersion
            osStandardDate
          }
        }
        totalCount
      }
    }
  }
`;

/**
 * Query for getting components
 */
export const GetComponentsQuery = gql`
  query CatalogSearchGetComponentsQuery(
    $pagination: PaginationInput
    $filter: ResourceCatalogComponentFilter
  ) {
    resources {
      componentsPaged(pagination: $pagination, filter: $filter) {
        components {
          id
          name
          title
          type
          description
          lifecycle
          techDocsRef
          source
          sourceLocationUrl
          scmSource
          scmSlug
          tags
          devHubOwner
          applicationsPaged {
            applications {
              applicationId
              name
            }
          }
        }
        totalCount
      }
    }
  }
`;

/**
 * Query for getting component APIs
 */
export const GetComponentAPIsQuery = gql`
  query CatalogSearchGetComponentAPIsQuery(
    $pagination: PaginationInput
    $filter: ResourceCatalogComponentApiFilter
  ) {
    resources {
      componentApisPaged(pagination: $pagination, filter: $filter) {
        componentApis {
          id
          name
          title
          type
          description
          definitionRef
          lifecycle
          devHubOwner
          source
          sourceLocationUrl
          scmSource
          scmSlug
        }
        totalCount
      }
    }
  }
`;
